import axiosInstance from "@/lib/axios";

// Voir docs/superpowers/specs/2026-09-21-livreurs-design.md (afrik-backend-api).
export const deliveryService = {
  // Liste des livreurs (admin), filtrable par statut.
  getDeliveries: async ({ page = 1, status = null }) => {
    let url = `/api/v1/admin/deliveries?page=${page}`;
    if (status) url += `&status=${status}`;

    const response = await axiosInstance.get(url);
    return response.data;
  },

  approve: async (id) => {
    const response = await axiosInstance.put(`/api/v1/admin/deliveries/${id}/approve`);
    return response.data;
  },

  // Refuse une demande avec motif obligatoire.
  reject: async (id, reason) => {
    const response = await axiosInstance.put(`/api/v1/admin/deliveries/${id}/reject`, {
      rejection_reason: reason,
    });
    return response.data;
  },

  // Bloque un livreur déjà validé (motif facultatif). Réactiver = approve().
  suspend: async (id, reason) => {
    const response = await axiosInstance.put(`/api/v1/admin/deliveries/${id}/suspend`, {
      rejection_reason: reason || null,
    });
    return response.data;
  },
};

export default deliveryService;
